export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LfvDhwtAAAAAN7YPjBqtH6-wkwED-lpEDbADtS6',
    /*siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',*/
  },


  /* baseUrl: 'https://periodtrackerdataprivac-development-ejgxcccbh9d5chb8.centralus-01.azurewebsites.net/api/'*/
  baseUrl: 'https://www.periodtrackerdataprivacylitigation.com/api/'
  /* baseUrl: 'https://localhost:7249/api/'*/
};

